module.exports = __webpack_public_path__ + "img/yezi7.e5739982.png";